import { render } from "./ViewBonLivraisonPage.vue?vue&type=template&id=1dc4d9fa&ts=true"
import script from "./ViewBonLivraisonPage.vue?vue&type=script&lang=ts"
export * from "./ViewBonLivraisonPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__